"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;var _objectSpread2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/objectSpread2"));















































































var _vuex = require("vuex");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({ username: 'getUsername' })), components: {}, data: function data() {return { tableData: [], // 列表数据
      searchData: { platId: '', deviceTypeId: '' }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, newadd: false, title: '新增', addData: { id: '', deviceTypeId: '', platId: '' }, defaultData: { id: '', deviceTypeId: '', platId: '' }, droplist: [], tableColumns: [{ prop: 'deviceTypeName', label: '设备名称', isShow: true }, { prop: 'operatorName', label: '操作人员', isShow: true }, { prop: 'updateTime', label: '操作时间', formatter: _formatter.dateFormatter, isShow: true }, { prop: 'countryRegionalNames', label: '服务地区', isShow: true }], rules: { deviceTypeId: [{ required: true, message: '请选择设备名称', trigger: 'blur' }] }, delIds: '' };}, mounted: function mounted() {var self = this;self.init();self.searchData.platId = self.$route.params.parentId;self.addData.platId = self.$route.params.parentId;}, methods: { init: function init() {var self = this;self.getData('/api/faPlatRefDeviceType', self.searchData, function (res) {self.tableData = res;});},
    getLanguageList: function getLanguageList() {
      var self = this;
      self.getData('/api/faDeviceType/getDownList', {}, function (res) {
        self.droplist = res;
      });
    },
    onCencal: function onCencal() {
      this.newadd = false;
      this.$refs['addForm'].resetFields();
    },
    delMenu: function delMenu(item) {
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/faPlatRefDeviceType', {
          id: item.id },
        function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.init();
        });
      }).catch(function () {});
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.getLanguageList();
      this.newadd = true;
    },
    closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();
      done();
    },
    onSubmit: function onSubmit() {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          var data = {
            platId: self.$route.params.parentId,
            deviceTypeId: self.addData.deviceTypeId };

          self.postData('/api/faPlatRefDeviceType', data, function (res) {
            self.$message({
              message: '新增成功!',
              type: 'success' });

            self.onCencal();
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    updateMenu: function updateMenu(item) {
      this.title = '编辑';
      var self = this;
      console.log(item);
      self.addData = {
        id: item.id,
        platId: item.platId,
        deviceTypeId: item.deviceTypeId };

      self.getLanguageList();
      self.newadd = true;
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faPlatRefDeviceType', self.addData, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.onCencal();
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    returnFun: function returnFun() {
      // 返回上一级
      this.$router.push('/configure/currency');
    } } };exports.default = _default;